import type { DebriefStage } from '@momentum/types';

export const DEEP_DIVE_QUESTION_COUNT = 3;

export type Turn =
  | { kind: 'fact-pick'; factId: string | null }
  | { kind: 'question'; questionIndex: number; answer: string }
  | { kind: 'lesson'; lessons: string[] };

export interface MatchPointSession {
  stage: DebriefStage;
  turns: Turn[];
  isCompleted: boolean;
}

export interface DeepDiveState {
  matchPoints: MatchPointSession[];
  isComplete: boolean;
}

export type DeepDiveAction =
  | { type: 'COMMIT_MATCH_POINTS'; payload: DebriefStage[] }
  | {
      type: 'PICK_FACT';
      payload: { matchPointIndex: number; factId: string };
    }
  | {
      type: 'ANSWER_QUESTION';
      payload: { matchPointIndex: number; answer: string };
    }
  | {
      type: 'ADD_LESSON';
      payload: { matchPointIndex: number; lesson: string };
    }
  | {
      type: 'EDIT_LESSON';
      payload: {
        matchPointIndex: number;
        lessonIndex: number;
        lesson: string;
      };
    }
  | {
      type: 'DELETE_LESSON';
      payload: { matchPointIndex: number; lessonIndex: number };
    }
  | { type: 'COMPLETE_MATCH_POINT'; payload: { matchPointIndex: number } }
  | { type: 'RESET' };
